import { tokens, getCssVariableValue } from '@domain-group/fe-brary';

/* eslint-disable import/prefer-default-export */

export var uvRoundelColour = () => [getCssVariableValue(tokens.colors.interactive.base.default)];